import AirConditionerIcon from 'Icons/AirConditioner';
import ProjectorIcon from 'Icons/Projector';
import SnackingIcon from 'Icons/Snacking';
import ChargerIcon from 'Icons/Charger';
import PrinterIcon from 'Icons/Printer';
import HandiIcon from 'Icons/Handi';
import TheaterIcon from 'Icons/Theater';
import BoardIcon from 'Icons/Board';
import WifiIcon from 'Icons/Wifi';
import SunIcon from 'Icons/Sun';
import WEIcon from 'Icons/WE';
import ChargingStationIcon from 'Icons/ChargingStation';
import ParkingMeterIcon from 'Icons/ParkingMeter';
import RestaurantIcon from 'Icons/Restaurant';
import HeartBeatIcon from 'Icons/HeartBeat';
import TerraceIcon from 'Icons/Terrace';
import LuggageIcon from 'Icons/Luggage';
import ParkingIcon from 'Icons/Parking';
import PubIcon from 'Icons/Pub';
import PoolIcon from 'Icons/Pool';
import BellIcon from 'Icons/Bell';
import SpaIcon from 'Icons/Spa';
import MicroIcon from 'Icons/MicroIcon';
import CameraIcon from 'Icons/CameraIcon';
import SmartScreenIcon from 'Icons/SmartScreenIcon';
import BroadbandIcon from 'Icons/BroadbandIcon';
import SpeakerIcon from 'Icons/Speaker';
import IslandLayoutIcon from 'Icons/IslandLayout';
export const space = [{
  value: 'WIFI',
  label: 'WIFI',
  short_label: 'Wifi',
  icon: WifiIcon
}, {
  value: 'Chargeurs Téléphone/PC',
  label: 'Chargeurs Téléphone/PC',
  short_label: 'Chargeurs',
  icon: ChargerIcon
}, {
  value: 'Impression/Photocopie/Scanner',
  short_label: 'Imprimante',
  icon: PrinterIcon
}, {
  value: 'Vidéoprojection',
  short_label: 'Projecteur',
  icon: ProjectorIcon
}, {
  value: 'Paperboard',
  short_label: 'Tableau',
  icon: BoardIcon
}, {
  value: 'theater',
  short_label: 'Théâtre',
  icon: TheaterIcon
}, {
  value: 'Lumière du jour',
  short_label: 'Lumière naturelle',
  icon: SunIcon
}, {
  value: 'Climatisation',
  short_label: 'Clim',
  icon: AirConditionerIcon
}, {
  value: 'Ouvert le weekend',
  short_label: 'Ouvert le W-E',
  icon: WEIcon
}, {
  value: 'Accès PMR',
  short_label: 'Accès PMR',
  icon: HandiIcon
}, {
  value: 'Snacking',
  label: 'Snacking',
  short_label: 'Snacking',
  icon: SnackingIcon
}, {
  value: 'Island',
  label: 'Îlots',
  short_label: 'Îlots',
  icon: IslandLayoutIcon
}];
export const etablishment = [{
  value: 'Bagagerie',
  icon: LuggageIcon
}, {
  value: 'Bar',
  icon: PubIcon
}, {
  value: 'Terrasse',
  icon: TerraceIcon
}, {
  value: 'Fitness',
  icon: HeartBeatIcon
}, {
  value: 'Piscine',
  icon: PoolIcon
}, {
  value: 'Conciergerie',
  icon: BellIcon
}, {
  value: 'Parking gratuit',
  icon: ParkingIcon
}, {
  value: 'Parking payant',
  icon: ParkingMeterIcon
}, {
  value: 'Restaurant',
  icon: RestaurantIcon
}, {
  value: 'spa',
  icon: SpaIcon
}, {
  value: 'wellness',
  icon: SpaIcon
}, {
  value: 'borne',
  icon: ChargingStationIcon
}];
export const hybrid_space = [{
  value: 'Micro',
  label: 'Micro',
  short_label: 'Micro',
  icon: MicroIcon
}, {
  value: 'Caméra',
  label: 'Caméra',
  short_label: 'Caméra',
  icon: CameraIcon
}, {
  value: 'Enceinte',
  label: 'Enceinte',
  short_label: 'Enceinte',
  icon: SpeakerIcon
}, {
  value: 'Ecran intelligent',
  label: 'Ecran intelligent',
  short_label: 'Ecran intelligent',
  icon: SmartScreenIcon
}, {
  value: 'Haut débit',
  label: 'Haut débit',
  short_label: 'Haut débit',
  icon: BroadbandIcon
}];
